import Blob from "cross-blob";
import { Document, HeadingLevel, Packer, Paragraph, TextRun } from "docx";

import { docStyles } from "./common";
import { numberingStyle } from "./common/numbering";
import { DocGenerator } from "../";
import { ApplicationFull } from "../../prisma";

interface EmptyRefereeLetterDocArgs {
  application: ApplicationFull;
  refereeName: string;
}

export const createEmptyRefereeLetterDoc: DocGenerator<
  EmptyRefereeLetterDocArgs
> = async (t, arg) => {
  const document = new Document({
    styles: docStyles,
    numbering: numberingStyle,
    sections: [
      {
        children: [
          new Paragraph({
            children: [
              new TextRun({
                text: `Reference Letter for ${arg.refereeName}`,
              }),
            ],
            heading: HeadingLevel.TITLE,
          }),

          new Paragraph({
            style: "wellSpaced",
          }),

          new Paragraph({
            children: [
              new TextRun({
                text: "Applicant: ",
                bold: true,
              }),
              new TextRun({
                text: arg.application.applicant.fullName
                  ? arg.application.applicant.fullName
                  : `${arg.application.applicant.firstName} ${arg.application.applicant.lastName}`,
              }),
            ],
          }),

          new Paragraph({}),

          new Paragraph({
            children: [
              new TextRun({
                text: "Referee: ",
                bold: true,
              }),
              new TextRun({
                text: arg.refereeName,
              }),
            ],
          }),

          new Paragraph({
            style: "wellSpaced",
          }),

          new Paragraph({
            children: [
              new TextRun({
                text: "[Please write your reference letter here]",
                italics: true,
              }),
            ],
          }),

          new Paragraph({
            style: "wellSpaced",
          }),

          new Paragraph({
            children: [
              new TextRun({
                text: "Sincerely,",
              }),
            ],
          }),

          new Paragraph({
            children: [
              new TextRun({
                text: arg.refereeName,
              }),
            ],
          }),
        ],
      },
    ],
  });

  return new Blob([await Packer.toBuffer(document)]);
};
